module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEeSURBVDiNpdGxUQJREMbx/96+As4OrgQsgYwRZ0zEIfMGzaUDpQKhAAbMDJwxMTCDDihBSjgzA95bA0AE3p0ybPp2fu/bXeGIarTzTL2ODAo9EpkANYEvORLJgLlXXz8YiiHvz+P5QVAZAvAn1GzdfIjI0yJZjMsQgOQfQVIzu1evszIkmqjRzjPn9cKg5tX3Ek8q6ARIgcKrP91F9hI1Lztd9Toz6AO5ep0EpTB8HSiA1AWXx2L/QGetTo7I4+rndWW7mJldxyC3mVGiDWtsuZfhSUnPJpFAIdBdjbCPBXdXhmwlwmRgYq9sj7Z5DuGzCkpguR8TW18mVkVwYVwJnV/dPggyqmrCrBc7+e9yZVdgubMpJoO3l+G08iPgG0LFjLBODcmeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy6.png
// module id = M+SJ
// module chunks = 1